import { FC, useState } from 'react'
import styled from 'styled-components'

type FormFieldProps = {
  children: string
  action: (value: string) => void
  name?: string
  placeholder? : string
}

const FormGroup = styled.div`
  margin-bottom: 15px;
`;

const Label = styled.label`
  font-size: 15px;
  font-weight: 500;
  display: block;
  padding: 0px 50px 0 5px;
  color: ${({ theme }) => theme.colors.text};
  line-height: normal;
  margin-bottom: 10px;
`;

const Input = styled.input`
  position: relative;
  background: transparent;
  border: 1px solid #0000003D;
  border-radius: ${({ theme }) => theme.border.radius.md};
  display: block;
  padding: 14px 20px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: #212121;
  width: 100%;
  height: auto;
  line-height: unset;
  transition: ease-in-out 0.5s;
  box-sizing: border-box;
`;

export const FormEmailField: FC<FormFieldProps> = ({ children, name, placeholder, action }) => {
  const [value, setValue] = useState<string>('')

  return (
    <FormGroup>
      <Label htmlFor={name}>{children}</Label>
      <Input
        type="email"
        id={name}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        required
        onBlur={() => action(value)}
      />
    </FormGroup>
  )
}

export const FormPasswordField: FC<FormFieldProps> = ({ children, name, placeholder, action }) => {
  const [value, setValue] = useState<string>('')

  return (
    <FormGroup>
      <Label htmlFor={name}>{children}</Label>
      <Input
        type="password"
        id={name}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        required
        onBlur={() => action(value)}
      />
    </FormGroup>
  )
}

export const FormTextField: FC<FormFieldProps> = ({ children, name, placeholder, action }) => {
  const [value, setValue] = useState<string>('')

  return (
    <FormGroup>
      <Label htmlFor={name}>{children}</Label>
      <Input
        type="text"
        id={name}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        required
        onBlur={() => action(value)}
      />
    </FormGroup>
  )
}

export const FormPhoneField: FC<FormFieldProps> = ({ children, name, placeholder, action }) => {
  const [value, setValue] = useState<string>('')

  return (
    <FormGroup>
      <Label htmlFor={name}>{children}</Label>
      <Input
        type="text"
        id={name}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        required
        onBlur={() => action(value)}
        pattern="^\+?[0-9]{1,3}[-.\s]?\(?\d{1,4}\)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$"
        title="ingresa un nuemro de telefono valido"
      />
    </FormGroup>
  )
}